import React from "react";
import Main from "./screens/Main";

function App() {
  return (
    <>
      <Main />
    </>
  );
}

export default App;
